import { useQuery } from "@tanstack/react-query";
import { supabase } from "@/integrations/supabase/client";
import { useAuth } from "@/contexts/AuthContext";
import { esStockFlexible, type StockControl } from "@/lib/stockControl";

export const STOCK_CONTROL_KEY = "stock-control";

/**
 * El «Control de stock» de ESTA empresa (`lib/stockControl`). Lo leen todos los
 * de la empresa (RLS de company_settings); lo cambia solo el admin.
 *
 * Ante la duda (cargando, error o sin fila), ESTRICTO: es lo que hace el
 * servidor, y pintar «faltan albaranes» donde el servidor va a bloquear sería
 * mentir.
 */
export function useStockControl() {
  const { company } = useAuth();
  const { data, isLoading } = useQuery({
    queryKey: [STOCK_CONTROL_KEY, company?.id ?? null],
    enabled: !!company?.id,
    queryFn: async (): Promise<{ control: StockControl; changedBy: string | null; changedAt: string | null }> => {
      const { data, error } = await supabase
        .from("company_settings")
        .select("stock_control, stock_control_changed_by, stock_control_changed_at")
        .eq("company_id", company!.id)
        .maybeSingle();
      if (error || !data) return { control: "strict", changedBy: null, changedAt: null };
      return {
        control: esStockFlexible(data.stock_control) ? "flexible" : "strict",
        changedBy: data.stock_control_changed_by ?? null,
        changedAt: data.stock_control_changed_at ?? null,
      };
    },
    staleTime: 5 * 60_000,
  });
  return {
    flexible: data?.control === "flexible",
    control: data?.control ?? ("strict" as StockControl),
    changedBy: data?.changedBy ?? null,
    changedAt: data?.changedAt ?? null,
    loading: isLoading,
  };
}
